import IMAGES from "../components/imagesVariable/imagesVariable";
export interface Officer {
  id: number;
  name: string;
  designation: string;
  department: string;
  email: string;
  phone: string;
  office: string;
  education: string;
  image: string;
}

export const officers: Officer[] = [
  {
    id: 1,
    name: "Dr. Abu Sayed Md. Mostafizur Rahaman",
    designation: "Teacher-in-Charge",
    department: "University Library",
    email: "asmmr@juniv.edu",
    phone: "+8801927129603",
    office: "University Library",
    education: "",
    image: IMAGES.AbuSayedMdMostafizurRahaman,
  },
  {
    id: 2,
    name: "M Salahuddin Bhuiya",
    designation: "Additional Teacher-in-Charge",
    department: "University Library",
    email: "salahuddin1976@juniv.edu",
    phone: "01818286236",
    office: "University Library",
    education: "",
    image: IMAGES.MSalahuddinBhuiya,
  },
  {
    id: 3,
    name: "Mohammad Ashraful Islam",
    designation: "Deputy Teacher-In-Charge",
    department: "University Library",
    email: "ashraful.islam@juniv.edu",
    phone: "01710548645",
    office: "University Library",
    education: "",
    image: IMAGES.MohammadAshrafulIslam,
  },
  {
    id: 4,
    name: "Md. Rezaul Haque",
    designation: "Deputy Librarian",
    department: "University Library",
    email: "shuvohr97@gmail.com",
    phone: "01927369402",
    office: "University Library, Ext. 1401",
    education: "",
    image: IMAGES.MdRezaulHaque,
  },
  // {
  //   id: 5,
  //   name: "Md. Badrul Alam (PRL)",
  //   designation: "Deputy Registrar",
  //   department: "University Library",
  //   email: "badrulalam62@gmail.com",
  //   phone: "01922803361",
  //   office: "University Library, Ext. 1409",
  //   education: "",
  //   image: "",
  // },
  //   {
  //     id: 6,
  //     name: "Md. Tauhidul Islam",
  //     designation: "Deputy Librarian",
  //     department: "University Library",
  //     email: "tauhiduljubd@gmail.com",
  //     phone: "01866371854",
  //     office: "University Library",
  //     education: "",
  //     image: "",
  //   },
  {
    id: 7,
    name: "Md. Habibe Kibria Chawdhury",
    designation: "Assistant Librarian",
    department: "University Library",
    email: "hkchowdhury016@juniv.edu",
    phone: "01812283752",
    office: "University Library",
    education: "",
    image: IMAGES.MdHabibeKibriaChawdhury,
  },
  {
    id: 8,
    name: "Mrs. Nazma Begum",
    designation: "Assistant Registrar",
    department: "University Library",
    email: "nazmabegum.ju@gmail.com",
    phone: "01681676624",
    office: "University Library",
    education: "",
    image: IMAGES.NazmaBegum,
  },
  {
    id: 9,
    name: "Md. Abdur Rahaman",
    designation: "Programmer",
    department: "University Library",
    email: "tamal.lib@juniv.edu",
    phone: "01914553408",
    office: "University Library, Ext. 2276",
    education: "",
    image: IMAGES.MdAbdurRahaman,
  },
  {
    id: 10,
    name: "Mrs. Jesmin Parvin",
    designation: "Assistant Librarian",
    department: "University Library",
    email: "parvinjesmin34@gmail.com",
    phone: "01911583197",
    office: "University Library",
    education: "",
    image: IMAGES.JesminParvin,
  },
  {
    id: 11,
    name: "Md. Bodiul Alam",
    designation: "Assistant Librarian",
    department: "University Library",
    email: "bodiul.lib@gmail.com",
    phone: "01933320262",
    office: "University Library",
    education: "",
    image: IMAGES.MdBodiulAlam,
  },
  {
    id: 12,
    name: "Md. Moklesur Rahman",
    designation: "Assistant Librarian",
    department: "University Library",
    email: "mmrahman.ju6@gmail.com",
    phone: "01911706722",
    office: "University Library",
    education: "",
    image: IMAGES.MdMoklesurRahman,
  },
  {
    id: 13,
    name: "Shimul Kumar Barua",
    designation: "Technical Officer (Library)",
    department: "University Library",
    email: "shimullibju@gmail.com",
    phone: "01731511729",
    office: "University Library",
    education: "",
    image: IMAGES.ShimulKumarBarua,
  },
  {
    id: 14,
    name: "Md. Faruk Hossain",
    designation: "Technical Officer (Library)",
    department: "University Library",
    email: "farukjubd@gmail.com",
    phone: "01752273571",
    office: "University Library",
    education: "",
    image: IMAGES.MdFarukHossain,
  },
  {
    id: 15,
    name: "Parveen Aktar",
    designation: "Administrative Officer",
    department: "University Library",
    email: "parveenaktarjubd@gmail.com",
    phone: "01716858849",
    office: "University Library",
    education: "",
    image: IMAGES.ParveenAktar,
  },
  {
    id: 16,
    name: "Md. Riaz Mahmud",
    designation: "Administrative Officer",
    department: "University Library",
    email: "riazmahmud@juniv.edu",
    phone: "01717648547",
    office: "University Library",
    education: "",
    image: IMAGES.MdRiazMahmud,
  },
];

export const designations: string[] = [
  "Teacher-in-Charge",
  "Additional Teacher-in-Charge",
  "Deputy Teacher-In-Charge",
  "Deputy Librarian",
  "Deputy Registrar",
  "Assistant Librarian",
  "Assistant Registrar",
  "Programmer",
  "Technical Officer (Library)",
  "Administrative Officer",
];

// Sample staff data - replace with actual API call or data import

export interface StaffMember {
  id: number;
  name: string;
  designation: string;
  department: string;
  email: string;
  phone: string;
  office: string;
  image: string;
}

export const sampleStaff: StaffMember[] = [
  {
    id: 1,
    name: "Md. Saidur Rahman",
    designation: "Senior Sorter (Grade-3)",
    department: "University Library",
    email: "example@juniv.edu",
    phone: "01747817455",
    office: "",
    image: IMAGES.MdSaidurRahman,
  },
  {
    id: 2,
    name: "Gazi Merajul Islam",
    designation: "Upper Division Assistant",
    department: "University Library",
    email: "gazimirajulislam74@gmail.com",
    phone: "01712642653",
    office: "",
    image: "",
  },
  {
    id: 3,
    name: "Md. Badiujjaman",
    designation: "Senior Book Sorter (Grade-1)",
    department: "University Library",
    email: "example@juniv.edu",
    phone: "01781230168",
    office: "",
    image: IMAGES.MdBadiujjaman,
  },
  {
    id: 4,
    name: "Biplob Kumar Sarkar",
    designation: "Senior Sorter (Grade-1)",
    department: "University Library",
    email: "example@juniv.edu",
    phone: "01883072006",
    office: "",
    image: IMAGES.BiplobKumarSarkar,
  },
  {
    id: 5,
    name: "Md. Masud Rana",
    designation: "Senior Book Sorter (Grade-3)",
    department: "University Library",
    email: "masud8386@gmail.com",
    phone: "01919349399",
    office: "",
    image: IMAGES.MdMasudRana,
  },
  {
    id: 6,
    name: "Mrs. Delowara Khatun",
    designation: "Senior Cleaner",
    department: "University Library",
    email: "example@juniv.edu",
    phone: "01754143710",
    office: "",
    image: IMAGES.DelowaraKhatun,
  },
  {
    id: 7,
    name: "Md. Abdul Motaleb",
    designation: "Senior Gardenar",
    department: "University Library",
    email: "example@juniv.edu",
    phone: "0190114491",
    office: "",
    image: IMAGES.MdAbdulMotaleb,
  },
  {
    id: 8,
    name: "Sree Gonesh",
    designation: "Senior Swiper (Grade-2)",
    department: "University Library",
    email: "sreegonesh8@gmail.com",
    phone: "01680248591",
    office: "",
    image: IMAGES.SreeGonesh,
  },
  {
    id: 9,
    name: "Rezowana Rahman",
    designation: "Senior Sorter",
    department: "University Library",
    email: "example@juniv.edu",
    phone: "01720644483",
    office: "",
    image: IMAGES.RezowanaRahman,
  },
  {
    id: 10,
    name: "Md. Abdul Based",
    designation: "Senior Assistant Book Binder",
    department: "University Library",
    email: "example@juniv.edu",
    phone: "01711141547",
    office: "",
    image: IMAGES.MdAbdulBased,
  },

  {
    id: 12,
    name: "Jahanara Akhter",
    designation: "Senior Cleaner Grade 2",
    department: "University Library",
    email: "example@juniv.edu",
    phone: "01819050594",
    office: "",
    image: IMAGES.JahanaraAkhter,
  },
  {
    id: 13,
    name: "Md. Amirul Islam",
    designation: "Assistant Book Binder",
    department: "University Library",
    email: "example@juniv.edu",
    phone: "01912163275",
    office: "",
    image: IMAGES.MdAmirulIslam,
  },
  {
    id: 14,
    name: "Md. Nurul Islam",
    designation: "Senior Cleaner Grade 2",
    department: "University Library",
    email: "islammdnurul505@gmail.com",
    phone: "01953450876",
    office: "",
    image: IMAGES.MdNurulIslam,
  },
  {
    id: 15,
    name: "Md. Gaziur Rahaman",
    designation: "Senior Electrician",
    department: "University Library",
    email: "gaziur71@gmail.com",
    phone: "01745462507",
    office: "",
    image: IMAGES.MdGaziurRahaman,
  },
  {
    id: 16,
    name: "Md. Kamal Hossain",
    designation: "Senior Book Sorter",
    department: "University Library",
    email: "kamalju26@gmail.com",
    phone: "01712489345",
    office: "",
    image: IMAGES.MdKamalHossain,
  },
  {
    id: 17,
    name: "Sree Trinad",
    designation: "Senior Swiper (Grade-2)",
    department: "University Library",
    email: "example@juniv.edu",
    phone: "01955323756",
    office: "",
    image: IMAGES.SreeTrinad,
  },
  {
    id: 18,
    name: "Md. Ali Hossain",
    designation: "Book Sorter",
    department: "University Library",
    email: "example@juniv.edu",
    phone: "01724812227",
    office: "",
    image: IMAGES.MdAliHossain,
  },
  {
    id: 19,
    name: "Prosanta Rajbongshi",
    designation: "Office Assistant Cum Computer Typist",
    department: "University Library",
    email: "prosantaraj.ju@gmail.com",
    phone: "01994005856",
    office: "",
    image: IMAGES.ProsantaRajbongshi,
  },
  {
    id: 20,
    name: "Palash Chandra Sarkar",
    designation: "Book Sorter",
    department: "University Library",
    email: "dhamraipalash@gmail.com",
    phone: "01953652872",
    office: "",
    image: IMAGES.PalashChandraSarkar,
  },
  {
    id: 21,
    name: "Bibi Sahara Banu",
    designation: "Cleaner Grade 1",
    department: "University Library",
    email: "example@juniv.edu",
    phone: "01789659247",
    office: "",
    image: IMAGES.BibiSaharaBanu,
  },
  {
    id: 22,
    name: "Md. Mizanur Rahaman",
    designation: "Swiper",
    department: "University Library",
    email: "example@juniv.edu",
    phone: "01961817309",
    office: "",
    image: IMAGES.MdMizanurRahaman,
  },
  {
    id: 23,
    name: "Rubina Akther",
    designation: "Cleaner",
    department: "University Library",
    email: "example@juniv.edu",
    phone: "01874739437",
    office: "",
    image: IMAGES.RubinaAkther,
  },
  {
    id: 24,
    name: "Maidul Islam (Mamun)",
    designation: "Cleaner",
    department: "University Library",
    email: "example@juniv.edu",
    phone: "01913324024",
    office: "",
    image: IMAGES.MaidulIslamMamun,
  },
  {
    id: 25,
    name: "Mofizul Islam(Saddam)",
    designation: "Cleaner",
    department: "University Library",
    email: "example@juniv.edu",
    phone: "01909045700",
    office: "",
    image: IMAGES.MofizulIslamSaddam,
  },
  {
    id: 26,
    name: "Taouhid Mollah",
    designation: "Office Assistant",
    department: "University Library",
    email: "taohidmollah100@gmail.com",
    phone: "01912807962",
    office: "",
    image: IMAGES.TaouhidMollah,
  },
  {
    id: 27,
    name: "Mahbubur Rahman",
    designation: "Office Assistant",
    department: "University Library",
    email: "mahbubsunny96@gmail.com",
    phone: "01627883354",
    office: "",
    image: IMAGES.MahbuburRahman,
  },
  {
    id: 28,
    name: "Mahady Hasan Raja",
    designation: "Office Assistant",
    department: "University Library",
    email: "mhking422@gmail.com",
    phone: "01401403567",
    office: "",
    image: IMAGES.MahadyHasanRaja,
  },
  {
    id: 29,
    name: "D Kartik",
    designation: "Swiper",
    department: "University Library",
    email: "karthikdasdas765@gmail.com",
    phone: "01995263641",
    office: "",
    image: IMAGES.DKartik,
  },
];

export const staffDesignations: string[] = [
  "Assistant Book Binder",
  "Book Sorter",
  "Cleaner",
  "Cleaner Grade 1",
  "Senior Assistant Book Binder",
  "Senior Book Sorter",
  "Senior Book Sorter (Grade-1)",
  "Senior Book Sorter (Grade-3)",
  "Senior Cleaner",
  "Senior Cleaner Grade 2",
  "Senior Electrician",
  "Senior Gardenar",
  "Senior Sorter",
  "Senior Sorter (Grade-1)",
  "Senior Sorter (Grade-3)",
  "Senior Swiper (Grade-2)",
  "Office Assistant",
  "Office Assistant Cum Computer Typist",
  "Upper Division Assistant",
  "Swiper",
];
